"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M0 0h24v24H0V0z",
    id: "path22",
    fill: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M 21.886257,1.0159152 H 11.593229 c -0.754821,0 -1.372403,0.6175817 -1.372403,1.3724037 v 9.6068281 c 0,0.754821 0.617582,1.372402 1.372403,1.372402 h 10.293028 c 0.754823,0 1.372404,-0.617581 1.372404,-1.372402 V 2.3883189 c 0,-0.754822 -0.617581,-1.3724037 -1.372404,-1.3724037 z m 0,1.3724037 V 4.4469245 H 11.593229 V 2.3883189 Z m -3.431009,9.6068281 h -3.43101 V 5.8193282 h 3.43101 z M 11.593229,5.8193282 h 2.058606 v 6.1758188 h -2.058606 z m 8.234423,6.1758188 V 5.8193282 h 2.058605 v 6.1758188 z",
    id: "path24",
    stroke: "currentColor",
    strokeWidth: "0.68674088",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m 17.072303,16.313706 v 3.787023 c 0,1.292139 -1.047488,2.339627 -2.339627,2.339627 H 4.2043554 c -1.2921397,-2e-6 -2.3396257,-1.047488 -2.3396257,-2.339627 V 9.5724077 c 0,-1.2921396 1.047486,-2.3396266 2.3396257,-2.3396266 h 3.1922032",
    id: "path12",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.33962679",
    strokeLinecap: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1"
  })]
}));